import { generatePassword } from '../../helpers/generate-password';
import { getRecaptchaToken } from '../../helpers/captchas';
import { processLogin } from '../../helpers/login';
import { generateUuid } from '../../helpers/strings';
import { TrackingHandler } from '../../tracking/TrackingHandler';
import { resolveSubmitId, resolveViewTime } from './form-state';
import { addTrackingData, getSubmissionHeaders, postJson } from './submission';
export const FREE_TRIAL_PASSWORD_LENGTH = 10;
export const LOGIN_REDIRECT_DELAY_MS = 2000;
export const FREE_TRIAL_TYPE_SHOW_NUMBER = 'Show number';
export const FREE_TRIAL_TYPE_REDIRECT = 'Redirect to portal';
export const FREE_TRIAL_FORM_NAME_SHOW_NUMBER = 'free_trial_live_test';
export const FREE_TRIAL_FORM_NAME_REDIRECT = 'free_trial';
export const LOGIN_CUSTOMER_TYPES = [
    'FREE_TRIAL',
    'ACTIVE_FREE_TRIAL',
    'REACTIVATED_FREE_TRIAL',
];
export const ensureFreeTrialPassword = (state) => {
    if (!state.password) {
        state.password = generatePassword(FREE_TRIAL_PASSWORD_LENGTH);
    }
    return state.password;
};
export const buildFreeTrialPayload = async (state, data, showNumber) => {
    data.submit_id_c = resolveSubmitId(state);
    data.vt = resolveViewTime(state);
    data.password = ensureFreeTrialPassword(state);
    data.form_name_c = state.formName;
    data.free_trial_type_c = showNumber ? FREE_TRIAL_TYPE_SHOW_NUMBER : FREE_TRIAL_TYPE_REDIRECT;
    data.rct = await getRecaptchaToken();
    return addTrackingData(data);
};
export const submitFreeTrialPayload = async (url, payload, alternateOrigin = null) => {
    const response = await postJson(url, payload, getSubmissionHeaders(alternateOrigin));
    return {
        ...(typeof response.body === 'object' && response.body !== null ? response.body : {}),
        statusCode: response.status,
    };
};
export const toTrackingResultData = (response) => {
    const responseData = {
        result: response.result,
        message: response.message,
    };
    if (typeof response.data === 'object' && response.data !== null) {
        if (typeof response.data.t === 'boolean') {
            responseData.t = response.data.t;
        }
        if (typeof response.data.i === 'string') {
            responseData.i = response.data.i;
        }
        if (typeof response.data.o === 'string') {
            responseData.o = response.data.o;
        }
        if (typeof response.data.customerType === 'string') {
            responseData.freeTrialType = response.data.customerType;
        }
    }
    return responseData;
};
export const loginFreeTrialCustomer = (username, password, loginDomain, alternateOrigin = null) => {
    const headers = {};
    if (alternateOrigin) {
        headers['x-alternate-origin'] = alternateOrigin;
    }
    const deviceId = TrackingHandler.getInstance().visitorId || generateUuid();
    return processLogin(username, password, deviceId, headers, loginDomain, null, 'register=true');
};
